import React, { Fragment } from 'react'
import { Select } from '@drifthq/tide-selects'
import Launcher from '@drifthq/integrated-help-launcher'
import * as R from 'ramda'
import config from 'config'

import { InstallOptions } from 'modules/org/constants'
import InstallJavascript from 'layouts/InstallJavascript'
import InstallSegment from 'layouts/InstallSegment'
import InstallWordpress from 'layouts/InstallWordpress'

import { variation } from 'modules/experiment/helpers'

import './style.css'

const getSnippet = (embedSnippet) => {
  return `<!-- Start of Async Drift Code -->\n${embedSnippet.trim()}\n<!-- End of Async Drift Code -->`
}

const INSTALL_OPTIONS = [
  {value: InstallOptions.JAVASCRIPT, label: "Javascript"},
  {value: InstallOptions.SEGMENT, label: "Segment"},
  {value: InstallOptions.WORDPRESS, label: "Wordpress"}
]

const InstallChoice = ({
  embedSnippet,
  installOption,
  onHelpWidgetClick,
  onInstallChange
}) => {
  return (
  <Fragment>
    <h1>Install Drift to start having conversations on your site</h1>
    <div className="install-exp-container">
      <Select
        label="Install Drift with:"
        options={INSTALL_OPTIONS}
        value={R.find(R.propEq('value', installOption), INSTALL_OPTIONS)}
        onChange={onInstallChange}
        className="install-exp-select"
      />
      {installOption==="JAVASCRIPT" && <InstallJavascript snippet={getSnippet(embedSnippet)}/>}
      {installOption==="SEGMENT" && <InstallSegment />}
      {installOption==="WORDPRESS" && <InstallWordpress snippet={getSnippet(embedSnippet)}/>}
    </div>
    { variation("touchless-help-widget-experiment") === "on" &&
      <div onClick={() => onHelpWidgetClick(config.INTERACTION_ID)}>
        <Launcher interactionId={config.INTERACTION_ID}/>
      </div>
    }
  </Fragment>
)}

export default InstallChoice


// WEBPACK FOOTER //
// ./src/layouts/InstallChoice/component.js